<template>
  <div class="user-statistics">

    <!-- START Search Zone -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-6">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 기간" label-for="searchPeriod"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchPeriod" v-model="searchForm.period"
                               range value-type="format" append-to-body lang="ko"
                               :disabled-date="disabledAfterYesterday" @input="search">
                    <template v-slot:footer="{ emit }">
                      <div class="text-start">
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodOneMonth(emit, 'yesterday')">
                          1개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodThreeMonth(emit, 'yesterday')">
                          3개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary" @click="$_utils.periodSixMonth(emit, 'yesterday')">
                          6개월
                        </b-button>
                      </div>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>
              <div class="col-xl-5 col-lg-6">
                <b-form-group class="ps-lg-3" label-class="form-check-label me-lg-3"
                              label="충전기 유형" label-for="searchEvseType"
                              label-cols="3" label-cols-lg="auto">
                  <div id="searchEvseType" class="col-form-label">
                    <div class="form-check form-check-inline" v-for="(evse, i) in evseTypeOptions">
                      <input class="form-check-input" type="radio"
                             name="inlineRadioOptions" :id="`inlineRadio${i}`"
                             :value="`${evse.value}`" v-model="searchForm.evseType"
                             @change="search" />
                      <label class="form-check-label" :for="`inlineRadio${i}`">{{ evse.name }}</label>
                    </div>
                  </div>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-lg-6 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Zone -->

    <!-- START Info Box Zone -->
    <div class="row">
      <div class="col-md-6 col-xl-3">
        <info-count-to card-bg="info" icon-image="mdi-account-group" icon-color="info"
                       title="전체 이용" value-title="건"
                       :end-val="$_utils.isEmpty(result.userTypeCount) ? 0 : result.userTypeCount.totalUsedCount" />
      </div>
      <div class="col-md-6 col-xl-3">
        <info-count-to card-bg="success" icon-image="mdi-account" icon-color="success"
                       title="회원 이용" valueTitle="건"
                       :end-val="$_utils.isEmpty(result.userTypeCount) ? 0 : result.userTypeCount.memberCount" />
      </div>
      <div class="col-md-6 col-xl-3">
        <info-count-to card-bg="warning" icon-image="mdi-account-alert" icon-color="warning"
                       title="로밍 이용" valueTitle="건"
                       :end-val="$_utils.isEmpty(result.userTypeCount) ? 0 : result.userTypeCount.roamingCount" />
      </div>
      <div class="col-md-6 col-xl-3">
        <info-count-to card-bg="secondary" icon-image="mdi-account-cancel" icon-color="secondary"
                       title="비회원 이용" valueTitle="건"
                       :end-val="$_utils.isEmpty(result.userTypeCount) ? 0 : result.userTypeCount.nonmemberCount" />
      </div>
    </div>
    <!-- END Info Box Zone -->

    <!-- START Usage Type -->
    <div class="row">
      <div class="col-12">
        <div class="card shadow">
          <div class="card-body">
            <card-title icon-image="mdi-account-group" title="이용자 유형" text-color="title" />
            <div class="row">
              <div class="col-lg-3 ct-mb-margin-bottom-100">
                <apexchart height="200" type="donut" :options="chartDonutOptions1" :series="chartDonutOptions1.series"
                           v-if="!$_utils.isEmpty(result.userTypeRate)" />
              </div>
              <div class="col-lg-3 ct-mb-margin-bottom-100">
                <apexchart height="200" type="donut" :options="chartDonutOptions2" :series="chartDonutOptions2.series"
                           v-if="!$_utils.isEmpty(result.userTypeRate)" />
              </div>
              <div class="col-lg-6">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>유형</th>
                      <th>이용</th>
                      <th>충전량</th>
                      <th>충전 금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in result.userTypeDetail" :class="{'last-tr':i==='3'}">
                      <th>{{ item.userType }}</th>
                      <td>{{ $_utils.comma(item.usedCount) }}</td>
                      <td>{{ $_utils.comma(item.totEnergy) }}</td>
                      <td>{{ $_utils.comma(item.totCost) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Usage Type -->

    <!-- START Bottom Zone -->
    <div class="row">

      <!-- START Chart -->
      <div class="col-lg-6">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 mb-2">
                <b-form-group class="ct-mb-margin-bottom-50" label-class="col-form-label"
                              label="충전소 유형" label-for="searchStationType"
                              label-cols="3" content-cols="9">
                  <b-form-select id="searchStationType" class="form-select"
                                 v-model="searchForm.stationType" :options="stationTypeOptions"
                                 @change="searchCondition('place')">
                    <template #first>
                      <b-form-select-option :value="'all'">전체</b-form-select-option>
                    </template>
                  </b-form-select>
<!--                  <multiselect id="searchStation" v-model="searchForm.stationType" :options="stationTypeOptions"
                               label="" placeholder="" select-label=""
                               @change="searchCondition('place')" />-->
                </b-form-group>
              </div>
              <div class="col-md-6 mb-2">
                <b-form-group class="mobile-margin-bottom-50" label-class="col-form-label"
                              label="충전소" label-for="searchStationName"
                              label-cols="3" content-cols="9">
                  <b-form-select id="searchStationName" class="form-select"
                                 v-model="searchForm.stationName" :options="stationNameOptions"
                                 @change="search()">
                    <template #first>
                      <b-form-select-option :value="'all'">전체</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
            <div id="wrapper" class="mt-4">
              <div id="chart-line">
                <apexchart ref="chart1" type="line" height="160"
                           :options="groupLineChartOptions" :series="groupLineChartOptions.series" />
              </div>
              <div id="chart-area">
                <apexchart ref="chart2" type="area" height="160"
                           :options="groupAreaChartOptions" :series="groupAreaChartOptions.series" />
              </div>
              <div id="chart-line2">
                <apexchart ref="chart3" type="line" height="160"
                           :options="groupLineChartOptions2" :series="groupLineChartOptions2.series" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END Chart -->

      <!-- START List -->
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <card-title icon-image="mdi-table-large" title="충전소 이용" text-color="title" />
            <div class="use-lank-table">
              <b-table class="datatables text-nowrap"
                       :sort-by.sync="useSortBy"
                       :sort-desc.sync="useSortDesc"
                       :fields="useFields" :items="useItems">
                <template #cell(userId)="data">
                  <span class="go-to-search" @click="goToUserReport">{{ data.item.userId }}</span>
                </template>
                <template #cell(placeType)="data">
                  {{ $_app.code.placeType[data.item.placeType] }}
                </template>
                <template #cell(evseCount)="data">
                  {{ $_utils.comma(data.item.evseCount) }}
                </template>
                <template #cell(chargeEnergy)="data">
                  {{ $_utils.comma(data.item.chargeEnergy) }}
                </template>
                <template #cell(chargeCost)="data">
                  {{ $_utils.comma(data.item.chargeCost) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <!-- END List -->

    </div>
    <!-- END Bottom Zone -->

  </div>
</template>

<script>
import infoCountTo from '@/views/components/infoCountTo.vue';
import Multiselect from 'vue-multiselect';
import EventBus from "@/views/layouts/event-bus";
import SearchButtons from "@/views/components/searchButtons.vue";
import cardTitle from "@/views/components/cardTitle.vue";

export default {
  components: { cardTitle, SearchButtons, infoCountTo, Multiselect },
  data() {
    return {
      searchForm: {
        // period: [new Date(moment('2023-05-01', 'YYYY-MM-DD')), new Date(moment().subtract(1, 'd').format('YYYY-MM-DD'))],
        period: [
          moment().date(1).format('YYYY-MM-DD'),
          moment().subtract(1, 'days').format('YYYY-MM-DD')
        ],
        evseType: 'all',
        stationType: 'all',
        stationName: 'all'
      },
      evseTypeOptions: [
        { value: 'all', name: '전체' },
        { value: 'slow', name: '완속' },
        { value: 'fast', name: '급속' },
      ],
      result: {
        userTypeCount: null,
        userTypeRate: null,
        userTypeDetail: null
      },
      chartDonutOptions1: {
        chart: {
          type: 'donut'
        },
        fill: {
          type: 'gradient'
        },
        legend: {
          show: true,
          fontSize: '14px',
          offsetX: 0,
          offsetY: 0
        },
        labels: ['회원', '비회원', '로밍'],
        colors: ['#2cb57e', '#adb5bd', '#f5bd58'],
        /*grid: {
          padding: {
            bottom: -80
          }
        },*/
        dataLabels: {
          style: {
            fontSize: '13px',
            fontWeight: 400
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 5,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#adb5bd',
            opacity: 0.9
          },
          dropShadow: {
            enabled: false
          }
        },
        tooltip: {
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value + '%'
            }
          }
        },
        plotOptions: {
          pie: {
            /*startAngle: -90,
            endAngle: 90,*/
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
            },
            donut: {
              size: '60%',
              labels: {
                show: true,
                name: {
                  offsetY: 5
                },
                value: {
                  show: false
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '충전량',
                  fontSize: '16px',
                  fontWeight: 600,
                  //color: '#373d3f'
                }
              }
            }
          }
        },
        series: []
      },
      chartDonutOptions2: {
        chart: {
          type: 'donut'
        },
        fill: {
          type: 'gradient'
        },
        legend: {
          show: true,
          fontSize: '14px',
          offsetX: 0,
          offsetY: 0
        },
        labels: ['회원', '비회원', '로밍'],
        colors: ['#2cb57e', '#adb5bd', '#f5bd58'],
        /*grid: {
          padding: {
            bottom: -80
          }
        },*/
        dataLabels: {
          style: {
            fontSize: '13px',
            fontWeight: 400
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 5,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#adb5bd',
            opacity: 0.9
          },
          dropShadow: {
            enabled: false
          }
        },
        tooltip: {
          y: {
            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
              return value + '%'
            }
          }
        },
        plotOptions: {
          pie: {
            /*startAngle: -90,
            endAngle: 90,*/
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
            },
            donut: {
              size: '60%',
              labels: {
                show: true,
                name: {
                  offsetY: 5
                },
                value: {
                  show: false
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: '충전 요금',
                  fontSize: '16px',
                  fontWeight: 600,
                  //color: '#373d3f'
                }
              }
            }
          }
        },
        series: []
      },
      stationTypeOptions: null,
      stationNameOptions: null,
      chartResult: null,
      groupLineChartOptions: {
        chart: {
          id: 'cnt',
          group: 'group-chart',
          type: 'line',
          height: 160
        },
        colors: ['#008bf3'],
        stroke: {
          curve: 'straight',
          width: 2
        },
        title: {
          text: '회원',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#8d8d8d'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          categories: [],
          tickAmount: 10,
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          }
        },
        series: [{
          name: '회원',
          data: []
        }]
      },
      groupAreaChartOptions: {
        chart: {
          id: 'power',
          group: 'group-chart',
          type: 'area',
          height: 160
        },
        colors: ['#546E7A'],
        stroke: {
          curve: 'straight',
          width: 2
        },
        title: {
          text: '비회원',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#8d8d8d'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          categories: [],
          tickAmount: 10,
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          }
        },
        series: [{
          name: '비회원',
          data: []
        }]
      },
      groupLineChartOptions2: {
        chart: {
          id: 'user',
          group: 'group-chart',
          type: 'line',
          height: 160
        },
        colors: ['#feb019'],
        stroke: {
          curve: 'straight',
          width: 2
        },
        grid: {
          show: true,
          xaxis: {
            lines: {
              show: false
            }
          },
          row: {
            opacity: 0.5
          },
        },
        title: {
          text: '로밍',
          align: 'left',
          style: {
            fontWeight: 'light',
            color:  '#8d8d8d'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime',
          categories: [],
          tickAmount: 10,
          labels: {
            format: 'MM/dd'
          },
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            formatter: function(val, index) {
              return Number(val).toLocaleString();
            }
          }
        },
        tooltip: {
          x: {
            format: 'yyyy-MM-dd'
          }
        },
        series: [{
          name: '로밍',
          data: []
        }]
      },
      useSortBy: 'chargeCount',
      useSortDesc: true,
      useFields: [
        /*{ key: 'rowNum', label: '순위' },*/
        { key: 'userId', label: '이용자 ID', sortable: true },
        { key: 'memberType', label: '유형', sortable: true },
        { key: 'chargeCount', label: '이용', sortable: true },
        { key: 'chargeEnergy', label: '충전량', sortable: true },
        { key: 'chargeCost', label: '충전 금액', sortable: true },
        { key: 'placeName', label: '주 이용 충전소', sortable: true }
      ],
      useItems: []
    }
  },
  mounted() {
    const vm = this;

    vm.search();
  },
  methods: {
    // reset() {
    //   const vm = this;
    //
    //   vm.searchForm = {
    //     period: [new Date(moment('2023-05-01', 'YYYY-MM-DD')), new Date(moment().subtract(1, 'd').format('YYYY-MM-DD'))],
    //     evseType: 'all',
    //     stationType: 'all',
    //     stationName: 'all'
    //   }
    //
    //   vm.search();
    // },
    disabledAfterYesterday(date) {
      return date > moment().subtract(1, 'days');
    },
    search() {
      const vm = this;

      vm.getItems();
      vm.searchCondition('placeType');
      //vm.getChartItems();
    },
    getItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-type`;

      this.$axios.get(_url, {
        params: {
          startDate: vm.searchForm.period[0],
          endDate: vm.searchForm.period[1],
          evseType: vm.searchForm.evseType
        }
      }).then((res) => {
        vm.result = Object.assign({}, res.data);
        /*vm.result.userTypeCount = Object.assign({}, res.data.userTypeCount);
        vm.result.userTypeRate = Object.assign({}, res.data.userTypeRate);
        vm.result.userTypeDetail = Object.assign({}, res.data.userTypeDetail);*/

        vm.chartDraw();
      });
    },
    chartDraw() {
      const vm = this;

      vm.userTypeChart();
    },
    userTypeChart() {
      const vm = this;

      let energyData = [
          vm.result.userTypeRate.memberEnergyRate,
          vm.result.userTypeRate.nonmemberEnergyRate,
          vm.result.userTypeRate.roamingEnergyRate
      ];
      vm.chartDonutOptions1.series = energyData;

      let costData = [
        vm.result.userTypeRate.memberCostRate,
        vm.result.userTypeRate.nonmemberCostRate,
        vm.result.userTypeRate.roamingCostRate
      ];
      vm.chartDonutOptions2.series = costData;
    },
    searchCondition(val) {
      const vm = this;
      const _url = `/onmapi/stats/by-place/search/${val}`;

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format("YYYY-MM-DD"),
          endDate: moment(vm.searchForm.period[1]).format("YYYY-MM-DD"),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType
        }
      }).then((res) => {
        if (val === 'placeType') {
          vm.stationTypeOptions = res.data.items.map(item => ({
            value: item.placeType,
            text: item.placeTypeName
          }));
        } else if (val === 'place') {
          vm.searchForm.stationName = 'all';
          vm.stationNameOptions = res.data.items.map(item => ({
            value: item.placeId,
            text: item.placeName
          }));
        }

        vm.getChartItems();
      }).catch((error) => {
        //this.$swal('데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    getChartItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-type/chart`;

      vm.getUseItems();

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format("YYYY-MM-DD"),
          endDate: moment(vm.searchForm.period[1]).format("YYYY-MM-DD"),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType,
          placeId: vm.searchForm.stationName
        }
      }).then((res) => {
        vm.chartResult = Object.assign({}, res.data);

        if (vm.chartResult.items.chartDatas.length > -1) {
          vm.drawGroupChart();
        }
      }).catch((error) => {
        //this.$swal('데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    drawGroupChart() {
      const vm = this;

      let chartData1 = [];
      let chartData2 = [];
      let chartData3 = [];
      let categories = [];



      vm.chartResult.items.chartDatas.forEach(item => {
        categories.push(item.statsTime);

        chartData1.push(item.memberUsedCount);
        chartData2.push(item.nonmemberUsedCount);
        chartData3.push(item.roamingUsedCount);
      });

      this.$refs.chart1.updateOptions({ xaxis: { categories: categories } });
      this.$refs.chart2.updateOptions({ xaxis: { categories: categories } });
      this.$refs.chart3.updateOptions({ xaxis: { categories: categories } });

      this.$refs.chart1.updateSeries([{ data: chartData1 }]);
      this.$refs.chart2.updateSeries([{ data: chartData2 }]);
      this.$refs.chart3.updateSeries([{ data: chartData3 }]);
    },
    getUseItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-type/rankuser`;

      this.$axios.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format("YYYY-MM-DD"),
          endDate: moment(vm.searchForm.period[1]).format("YYYY-MM-DD"),
          evseType: vm.searchForm.evseType,
          placeType: vm.searchForm.stationType,
          placeId: vm.searchForm.stationName
        }
      }).then((res) => {
        //vm.visibleFields();
        vm.useItems = res.data.items;
      }).catch((error) => {
        //this.$swal('데이터 조회 실패', '', 'error');
        console.error(error)
      });
    },
    goToUserReport(e) {
      const vm = this;
      const targetUserId = e.currentTarget.innerText;
      const searchMonth = this.$moment(vm.searchForm.period[0]).format('YYYY-MM');

      EventBus.$emit('go-to-user-report', searchMonth, targetUserId)
    }
  }
}
</script>
